import { z } from "zod";

export enum SignatureMethod {
    Manual = "manual",
    MagicLink = "magicLink",
}

export const SignatureMethodSchema = z.nativeEnum(SignatureMethod);

